<div class="center">
  <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
</div>

<p-dialog
  [(visible)]="showRuaDialog"
  modal="modal"
  baseZIndex="1"
  minHeight = "900">

  <ng-template pTemplate="header">
    Regional User Agreement
  </ng-template>

  <p-table
    [columns]="headers"
    [styleClass]="'btable'"
    [value]="regions"
    [autoLayout]="true"
    id="rua-table"
  >

    <ng-template pTemplate="header" let-regions>
      <tr>
        <th class="rua-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns">
          {{col.header}}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" class="rua-tbl-body" let-region>
      <tr>
        <td>
          <p-checkbox [inputId]="'chkbox-' + region.id" [value]="region.label" [name]="region.id" [label]="region.label"
                      [(ngModel)]="selectedRegions"></p-checkbox>
        </td>
        <td>
          <p-inputMask [inputId]="'contract-number-' + region.id" [disabled]="!isRegionSelected(region.label)"
                       [(ngModel)]="ruaMap[region.label].contractNumber" [autoClear]="false" mask="****-RUA-aa-2099"
                       [name]="'contract-number-' + region.id" placeholder="XXXX-RUA-XX-20XX"></p-inputMask>
        </td>
        <td>
          <p-calendar [inputId]="'expiration-date-' + region.id"
                      [disabled]="!isRegionSelected(region.label)"
                      [(ngModel)]="ruaMap[region.label].expirationDate"
                      [name]="'expiration-date-' + region.id"
                      placeholder="YYYY-MM-DD"
                      slotChar="YYYY-MM-DD"
                      dateFormat="yy-mm-dd"
          ></p-calendar>
        </td>
        <td>
          <label [id]="'btn-upload-rua-for-' + region.id" [class]="btnChooseRuaFile(region.label)"
                 [for]="'rua-' + region.id">Choose File</label>
          <input [id]="'rua-' + region.id" [name]="'rua-' + region.id" #ruaFileInput style="display:none" type="file" accept=".pdf"
                 (change)="processUploadedRuaFile(region.label, $event.target.files)"
                 [disabled]="!isRegionSelected(region.label)">
          <label *ngIf="ruaMap[region.label].attachmentId != ''" [id]="'uploaded-rua-name-' + region.id" class="file-info"><a href="{{attachmentUrl+ruaMap[region.label].attachmentId}}">download</a></label>
          <label *ngIf="ruaMap[region.label].attachmentId == '' && ruaMap[region.label].ruaUserFileName != ''" [id]="'uploaded-rua-name-' + region.id" class="file-info"><strong>{{ruaMap[region.label].ruaUserFileName}}</strong></label>
          <label *ngIf="ruaMap[region.label].attachmentId == '' && ruaMap[region.label].ruaUserFileName == ''" [id]="'uploaded-rua-name-' + region.id" class="file-info">No file chosen</label>
        </td>
      </tr>
    </ng-template>

  </p-table>


  <ng-template pTemplate="footer">
    <button id="rua-yes" type="button" class="btn btn-default width-100px" (click)="save()">Save</button>
    <span style="margin-left: 1.5em;"></span>
    <button id="rua-no" type="button" class="btn btn-secondary width-100px" (click)="hide()">Cancel</button>
    <span style="margin-left: 3em;"></span>
  </ng-template>
</p-dialog>
